"use client";

import "./industry-hotel.css";
import { useEffect } from "react";

const solutions = [
  {
    image: "/assets/images/Enterprise-transforamtion.jpg",
    title: "Enterprise Transformation",
    href: "/enterprise-transformation",
    text: "S/4HANA | Finance | Procurement | Assets | Projects | Retail & F&B | Integration | BTP",
  },
  {
    image: "/assets/images/people-change-business.jpg",
    title: "Human Transformation",
    href: "/enterprise-transformation/successfactors",
    text: "SuccessFactors | Workforce Planning | Talent | Learning | Performance | Scheduling | Skills",
  },
  {
    image: "/assets/images/data_sap_bdc.jpg",
    title: "Data & AI Intelligence",
    href: "/datasap",
    text: "Enterprise Data | Analytics | Data Science | ML | AI | Agents | Demand Forecasting | Decision Intelligence",
  },
  {
    image: "/assets/images/hotel.jpg",
    title: "Guest & Service Intelligence",
    href: "/coming-soon",
    text: "Guest 360 (Sovereign CRM) | Service Management | Feedback & Sentiment | Loyalty & Personalisation | Omni-channel Service",
  },
  {
    image: "/assets/images/Operate_improve.jpg",
    title: "Operate & Improve",
    href: "/Operate",
    text: "AMS | Applications | Data Operations | Controls & Compliance | Automation | Continuous Improvement",
  },
];

const valueChain = [
  ["PROPERTY", "Buildings", "/assets/images/Property.jpg", "center"],
  ["ROOMS", "Rooms", "/assets/images/rooms.jpg", "center"],
  ["F&B", "Food & Beverage", "/assets/images/food-&-Beverage.jpg", "center"],
  ["EVENTS", "Events", "/assets/images/Events.jpg", "center"],
  ["GUEST", "Guest", "/assets/images/guest.jpg", "center"],
  ["LOYALTY", "Loyalty", "/assets/images/Loyalty.jpg", "center"],
];

const chainLayers = [
  ["people", "PEOPLE", "Workforce | Skills | Scheduling | Performance"],
  ["building", "ASSETS", "Buildings | Rooms | F&B Equipment | Facilities | Maintenance"],
  ["cart", "PROCUREMENT", "Inventory | Suppliers | Contracts | Spend"],
  ["chart", "FINANCE", "Revenue | Cost | Cash | Profitability"],
  ["layers", "DATA & AI", "Plan vs Actual | Forecast | Predict | Recommend"],
];

const keyQuestions = [
  "Why is occupancy up but profitability down?",
  "Which properties or services are underperforming?",
  "Where is procurement spend leaking?",
  "Which F&B inventory is being wasted?",
  "Which assets require management attention?",
  "Do we have the right workforce by property?",
  "Which guest service exceptions need action?",
  "What should management know today?",
  "How can AI improve decisions, not just dashboards?",
];

const reconciliationSteps = [
  ["01", "Rooms", "PMS", "bed"],
  ["02", "F&B", "POS", "fork"],
  ["03", "Events & Banquets", "BEO / POS", "calendar"],
  ["04", "Procurement", "PO / Invoice", "cart"],
  ["05", "Inventory", "Consumption", "layers"],
  ["06", "Payroll", "Roster / Attendance", "people"],
  ["07", "Assets & Maintenance", "Work Orders", "wrench"],
  ["08", "Other Revenue", "Spa / Retail / Other", "chart"],
];

const financialFlow = [
  ["document", "PLAN / BUDGET", "Property | Department | Revenue | Cost Centre"],
  ["layers", "ACTUAL BUSINESS", "Transactions from all systems"],
  ["layers", "ACTUAL MONEY", "Receivables | Payments | Bank | GL"],
  ["search", "RECONCILE", "Plan vs Actual"],
  ["bulb", "VARIANCE & EXPLANATION", "Why did it change?"],
  ["chart", "FORECAST & TAKE ACTION", "What happens next?"],
];

const outputs = [
  ["chart", "Revenue Reconciliation"],
  ["layers", "Cost Variance Analysis"],
  ["pieChart", "Department Profitability"],
  ["cart", "Cash & Collection Tracking"],
  ["document", "Property P&L"],
  ["grid", "Portfolio View"],
  ["brain", "AI-Driven Insights"],
  ["gear", "Management Actions"],
];

const intelligence = [
  {
    icon: "building",
    title: "Property Performance AI",
    text: "Occupancy, revenue, cost and profitability",
  },
  {
    icon: "fork",
    title: "F&B Intelligence",
    text: "Demand, purchasing, consumption, wastage and menu profitability",
  },
  {
    icon: "wrench",
    title: "Asset & Maintenance AI",
    text: "Predict issues, optimise maintenance and cost",
  },
  {
    icon: "cart",
    title: "Procurement Intelligence",
    text: "Supplier risk, price variance and spend anomalies",
  },
  {
    icon: "people",
    title: "Workforce Intelligence",
    text: "Forecast workforce needs and optimise scheduling",
  },
  {
    icon: "guest",
    title: "Guest Intelligence",
    text: "Understand experience, service issues and opportunities",
  },
  {
    icon: "chart",
    title: "CXO Portfolio Intelligence",
    text: "Compare properties, explain exceptions and recommend actions",
  },
];

const enterpriseSystems = [
  ["SAP", "S/4HANA", "layers"],
  ["SuccessFactors", "People", "people"],
  ["Ariba", "Procurement", "cart"],
  ["Concur", "Expenses", "chart"],
  ["Oracle", "Property / PMS", "building"],
  ["POS", "F&B", "fork"],
  ["BTP", "Integration", "layers"],
  ["Other", "Systems", "wrench"],
];

const portfolio = [
  { title: "CITY HOTEL", image: "/assets/images/Property.jpg" },
  { title: "RESORT", image: "/assets/images/resort (1).jpg" },
  { title: "BUSINESS HOTEL", image: "/assets/images/rooms.jpg" },
  { title: "AIRPORT HOTEL", image: "/assets/images/airport-hotel.jpg" },
  { title: "MULTI-PROPERTY PORTFOLIO", image: "/assets/images/multi-property-portfolio.jpg" },
];

/* =========================================================
   SVG ICON SYSTEM
========================================================= */

const svgProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const IconBuilding = () => (
  <svg {...svgProps}>
    <rect x="4" y="3" width="10" height="18" rx="1" />
    <rect x="16" y="9" width="4" height="12" rx="1" />
    <path d="M7 7h1M11 7h1M7 11h1M11 11h1M7 15h1M11 15h1" />
  </svg>
);

const IconBed = () => (
  <svg {...svgProps}>
    <path d="M3 18v-7a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v3" />
    <path d="M13 14h6a2 2 0 0 1 2 2v2" />
    <path d="M3 14h18v4" />
    <path d="M3 18v3M21 20v1" />
    <circle cx="7" cy="10.5" r="1.5" />
  </svg>
);

const IconFork = () => (
  <svg {...svgProps}>
    <path d="M6 2v7a2 2 0 0 0 4 0V2" />
    <path d="M8 9v13" />
    <path d="M17 2c-1.8 1-2.6 2.8-2.6 5.4 0 2 .9 3.4 2.6 3.6" />
    <path d="M17 2v20" />
  </svg>
);

const IconCalendar = () => (
  <svg {...svgProps}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18" />
    <path d="M8 3v4M16 3v4" />
  </svg>
);

const IconGuest = () => (
  <svg {...svgProps}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8" />
  </svg>
);

const IconHeart = () => (
  <svg {...svgProps}>
    <path d="M12 20s-7-4.5-9.4-8.9A5.4 5.4 0 0 1 12 5.3a5.4 5.4 0 0 1 9.4 5.8C19 15.5 12 20 12 20z" />
  </svg>
);

const IconWrench = () => (
  <svg {...svgProps}>
    <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.8 2.8-2-2 2.8-2.8z" />
  </svg>
);

const IconChart = () => (
  <svg {...svgProps}>
    <path d="M4 20V11" />
    <path d="M10 20V6" />
    <path d="M16 20V9" />
    <path d="M22 20V3" />
  </svg>
);

const IconCart = () => (
  <svg {...svgProps}>
    <circle cx="9" cy="20" r="1" fill="currentColor" stroke="none" />
    <circle cx="18" cy="20" r="1" fill="currentColor" stroke="none" />
    <path d="M2 3h2l2.4 12.2a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L21 7H6" />
  </svg>
);

const IconPeople = () => (
  <svg {...svgProps}>
    <circle cx="9" cy="8" r="3" />
    <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M15.5 14a5 5 0 0 1 5.5 5" />
  </svg>
);

const IconLayers = () => (
  <svg {...svgProps}>
    <path d="M12 2 2 7l10 5 10-5-10-5z" />
    <path d="M2 12l10 5 10-5" />
    <path d="M2 17l10 5 10-5" />
  </svg>
);

const IconArrowRight = () => (
  <svg {...svgProps}>
    <path d="M4 12h15" />
    <path d="M13 6l6 6-6 6" />
  </svg>
);

const IconArrowDown = () => (
  <svg {...svgProps}>
    <path d="M12 4v15" />
    <path d="m6 13 6 6 6-6" />
  </svg>
);

const IconBrain = () => (
  <svg {...svgProps}>
    <path d="M9 3a3 3 0 0 0-3 3 3 3 0 0 0-2 5 3.5 3.5 0 0 0 1.5 6.4A3 3 0 0 0 8.5 21c1.5 0 2.5-1 2.5-2V6a3 3 0 0 0-2-3z" />
    <path d="M15 3a3 3 0 0 1 3 3 3 3 0 0 1 2 5 3.5 3.5 0 0 1-1.5 6.4A3 3 0 0 1 15.5 21c-1.5 0-2.5-1-2.5-2V6a3 3 0 0 1 2-3z" />
  </svg>
);

const IconGear = () => (
  <svg {...svgProps}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 3v2M12 19v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M3 12h2M19 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" />
  </svg>
);

const IconDocument = () => (
  <svg {...svgProps}>
    <path d="M6 2h9l3 3v17H6z" />
    <path d="M15 2v3h3" />
    <path d="M9 12h6M9 16h6M9 8h3" />
  </svg>
);

const IconSearch = () => (
  <svg {...svgProps}>
    <circle cx="11" cy="11" r="7" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);

const IconBulb = () => (
  <svg {...svgProps}>
    <path d="M9 18h6M10 21h4" />
    <path d="M12 3a6 6 0 0 0-3.5 10.9c.6.4 1 1.1 1 1.9v.2h5v-.2c0-.8.4-1.5 1-1.9A6 6 0 0 0 12 3z" />
  </svg>
);

const IconPieChart = () => (
  <svg {...svgProps}>
    <path d="M21 12A9 9 0 1 1 12 3v9z" />
    <path d="M21 12a9 9 0 0 1-9 9" />
  </svg>
);

const IconGrid = () => (
  <svg {...svgProps}>
    <rect x="3" y="3" width="8" height="8" rx="1" />
    <rect x="13" y="3" width="8" height="8" rx="1" />
    <rect x="3" y="13" width="8" height="8" rx="1" />
    <rect x="13" y="13" width="8" height="8" rx="1" />
  </svg>
);

const ICONS = {
  building: IconBuilding,
  bed: IconBed,
  fork: IconFork,
  calendar: IconCalendar,
  guest: IconGuest,
  heart: IconHeart,
  wrench: IconWrench,
  chart: IconChart,
  cart: IconCart,
  people: IconPeople,
  layers: IconLayers,
  arrowRight: IconArrowRight,
  arrowDown: IconArrowDown,
  brain: IconBrain,
  gear: IconGear,
  document: IconDocument,
  search: IconSearch,
  bulb: IconBulb,
  pieChart: IconPieChart,
  grid: IconGrid,
};

function Icon({ type, className = "" }) {
  const Component = ICONS[type];
  if (!Component) return null;

  return (
    <span className={`hospitality-icon ${className}`} aria-hidden="true">
      <Component />
    </span>
  );
}

export default function HospitalityPage() {
  useEffect(() => {
    const items = document.querySelectorAll(".hospitality-reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
    );

    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="hospitality-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="hospitality-hero">
        <div className="hospitality-hero-image-wrap">
          <img
            src="/assets/images/Hotelshero.jpg"
            alt="Hotels and hospitality"
          />
        </div>

        <div className="hospitality-hero-bg" />

        <div className="hospitality-container hospitality-hero-inner">

          <div className="hospitality-hero-content hospitality-reveal">

           
            <h1>
              From Property to Guest.
              <br />
              From Operations to
              <br />
              Experience and Value.
            </h1>

            <p className="hospitality-hero-lead">
              Enterprise systems. People. Data. AI.
            </p>

            <p className="hospitality-hero-description">
              For a more profitable and memorable hospitality business.
              Connect hotel groups and hospitality enterprises across
              operations, finance, procurement, people, assets and guest
              service data, and apply AI to improve performance, control
              cost and elevate guest experience.
            </p>

            <div className="hospitality-hero-buttons">
              <a href="/tellusyourproblem#tell-details" className="hospitality-btn primary">
                Tell Us Your Problem
                <Icon type="arrowRight" />
              </a>

              <a href="#solutions" className="hospitality-btn secondary">
                See How It Works
                <span className="hospitality-play-icon">▶</span>
              </a>
            </div>

            <div className="hospitality-hero-stats">
              {[
                ["chart", "HIGHER", "PROFITABILITY"],
                ["guest", "BETTER", "GUEST EXPERIENCE"],
                ["cart", "LOWER", "OPERATING COST"],
                ["wrench", "OPTIMISED", "ASSETS & FACILITIES"],
                ["people", "A MORE", "ENGAGED WORKFORCE"],
                ["chart", "DATA-DRIVEN", "DECISIONS"],
                ["heart", "A STRONGER", "BRAND"],
              ].map(([icon, line1, line2]) => (
                <div className="hospitality-hero-benefit" key={line1}>
                  <div className="hospitality-hero-benefit-icon">
                    <Icon type={icon} />
                  </div>
                  <span>
                    {line1}
                    <br />
                    {line2}
                  </span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>


      {/* =====================================================
          QUESTIONS
      ===================================================== */}

      <section className="hospitality-section" id="questions">
        <div className="hospitality-container">

          <div className="hospitality-questions-card hospitality-reveal">

            <div className="hospitality-questions-content">

              <div className="hospitality-section-heading">
                <h2>Key Questions We Help Answer</h2>
                <p>
                  Business questions that connect operational reality
                  to financial and guest outcomes — across the full
                  hospitality value chain.
                </p>
              </div>

              <div className="hospitality-questions-list">
                {keyQuestions.map((question, index) => (
                  <div className="hospitality-question-item" key={question}>
                    <span className="hospitality-question-number">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <p>{question}</p>

                    <span className="hospitality-question-arrow">
                      <Icon type="arrowRight" />
                    </span>
                  </div>
                ))}
              </div>

              <a href="#value-chain" className="hospitality-questions-more">
                Explore The Value Chain
                <Icon type="arrowRight" />
              </a>

            </div>

            <div className="hospitality-questions-image">
              <img
                src="/assets/images/hotelq.jpg"
                alt="Hotels and hospitality"
              />
            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          VALUE CHAIN
      ===================================================== */}

      <section className="hospitality-section" id="value-chain">
        <div className="hospitality-container">

          <div className="hospitality-section-heading hospitality-reveal">
            <h2>The Hospitality Value Chain</h2>
            <p>
              Connecting every part of the business.
            </p>
          </div>

          <div className="hospitality-value-chain-card hospitality-reveal">

            <div className="hospitality-value-chain-top">
              {valueChain.map(([title, text, image, pos]) => (
                <div className="hospitality-value-chain-item" key={title}>

                  <div className="hospitality-value-chain-item-image">
                    <img
                      src={image}
                      alt={title}
                      style={{ objectPosition: pos }}
                    />
                  </div>

                  <div className="hospitality-value-chain-item-footer">

                    <div className="hospitality-value-chain-item-text">
                      <strong>{title}</strong>
                      <span>{text}</span>
                    </div>

                  </div>

                </div>
              ))}
            </div>

            <div className="hospitality-value-chain-list">
              {chainLayers.map(([icon, title, text]) => (
                <div className="hospitality-chain-layer" key={title}>

                  <div className="hospitality-chain-layer-label">
                    <span className="hospitality-chain-layer-icon">
                      <Icon type={icon} />
                    </span>
                    <strong>{title}</strong>
                  </div>

                  <span className="hospitality-chain-layer-text">
                    {text}
                  </span>

                </div>
              ))}
            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          END TO END SOLUTION
      ===================================================== */}

      <section className="hospitality-section" id="solutions">
        <div className="hospitality-container">

          <div className="hospitality-section-heading hospitality-reveal">
            <h2>Our End-to-End Hospitality Solution</h2>
            <p>
              Transform. Connect. Analyse. Reconcile. Improve.
            </p>
          </div>

          <div className="hospitality-solution-grid">
            {solutions.map((solution, index) => (
              <a
                href={solution.href}
                className={`hospitality-solution-card hospitality-solution-card-${index + 1}`}
                key={solution.title}
                style={{ backgroundImage: `url(${solution.image})` }}
              >
                <h3>{solution.title}</h3>

                <div className="hospitality-solution-reveal">
                  <p>{solution.text}</p>
                </div>
              </a>
            ))}
          </div>

        </div>
      </section>


      {/* =====================================================
          FINANCIAL RECONCILIATION
      ===================================================== */}

      <section className="hospitality-section" id="reconciliation">
        <div className="hospitality-container">

          <div className="hospitality-section-heading hospitality-reveal">
            <h2>Plan and Actual Money Reconciliation</h2>
            <p>
              From operations to financial truth. End-to-end.
            </p>
          </div>

          <div className="hospitality-reconciliation-layout hospitality-reveal">

            <div className="hospitality-source-list">
              {reconciliationSteps.map(
                ([number, title, text, icon]) => (
                  <div className="hospitality-source-row" key={number}>
                    <span className="hospitality-source-icon">
                      <Icon type={icon} />
                    </span>

                    <div>
                      <strong>{title}</strong>
                      <small>{text}</small>
                    </div>
                  </div>
                )
              )}
            </div>

            <div className="hospitality-finance-flow">
              {financialFlow.map(([icon, title, text], index) => (
                <div
                  className={`hospitality-finance-step${
                    index === financialFlow.length - 1 ? " highlight" : ""
                  }`}
                  key={title}
                >
                  <span className="hospitality-finance-step-icon">
                    <Icon type={icon} />
                  </span>

                  <div>
                    <strong>{title}</strong>
                    <span>{text}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="hospitality-output-box">

              <h3>Key Outputs</h3>

              {outputs.map(([icon, label]) => (
                <div className="hospitality-output-item" key={label}>
                  <span className="hospitality-output-icon">
                    <Icon type={icon} />
                  </span>
                  <p>{label}</p>
                </div>
              ))}

            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          AI USE CASES
      ===================================================== */}

      <section className="hospitality-section" id="ai-use-cases">
        <div className="hospitality-container">

          <div className="hospitality-section-heading hospitality-reveal">
            <h2>AI Use Cases for Hotels & Hospitality</h2>
            <p>
              From insight to action. Real business impact.
            </p>
          </div>

          <div className="intelligence-list hospitality-reveal">
            {intelligence.map((item) => (
              <div
                className="intelligence-item"
                key={item.title}
              >
                <Icon type={item.icon} />

                <div>
                  <strong>{item.title}</strong>
                  <p>{item.text}</p>
                </div>

                <span className="intelligence-item-arrow" aria-hidden="true">
                  <Icon type="arrowRight" />
                </span>
              </div>
            ))}
          </div>

        </div>
      </section>


      {/* =====================================================
          BUSINESS EXAMPLE
      ===================================================== */}

      <section className="hospitality-section" id="business-example">
        <div className="hospitality-container">

          <div className="hospitality-section-heading hospitality-reveal">
            <h2>Example: Occupancy is Up. Why is Profit Down?</h2>
            <p>
              AI explains the drivers, simulates options
              and recommends actions.
            </p>
          </div>

          <div className="hospitality-business-example hospitality-reveal">

            <div className="hospitality-example-top">

              <div className="hospitality-example-metric">
                <span className="hospitality-example-metric-icon">
                  <Icon type="bed" />
                </span>
                <strong>Occupancy <i>↑</i></strong>
                <span className="hospitality-example-bars">
                  <i /><i /><i /><i />
                </span>
              </div>

              <div className="hospitality-example-metric">
                <span className="hospitality-example-metric-icon">
                  <Icon type="layers" />
                </span>
                <strong>Revenue <i>↑</i></strong>
                <span className="hospitality-example-bars">
                  <i /><i /><i /><i />
                </span>
              </div>

              <div className="hospitality-example-metric negative">
                <span className="hospitality-example-metric-icon">
                  <Icon type="chart" />
                </span>
                <strong>Profit <i>↓</i></strong>
                <span className="hospitality-example-bars">
                  <i /><i /><i /><i />
                </span>
              </div>

            </div>

            <div className="hospitality-driver-grid">

              <div className="hospitality-driver-card">

                <div className="hospitality-driver-card-text">
                  <h3>Room Revenue</h3>
                  <ul>
                    <li>ADR / Discount</li>
                    <li>Channel Mix</li>
                    <li>OTA Commission</li>
                    <li>Room Mix</li>
                  </ul>
                </div>

                <div className="hospitality-driver-card-media">
                  <img
                    src="/assets/images/bedd.png"
                    alt="Room Revenue"
                  />
                </div>

              </div>

              <div className="hospitality-driver-card">

                <div className="hospitality-driver-card-text">
                  <h3>Cost Increase</h3>
                  <ul>
                    <li>Payroll</li>
                    <li>F&B Cost</li>
                    <li>Energy</li>
                    <li>Procurement</li>
                    <li>Maintenance</li>
                  </ul>
                </div>

                <div className="hospitality-driver-card-media">
                  <img
                    src="/assets/images/Hotels & hospitallity.png"
                    alt="Cost Increase"
                    style={{ objectPosition: "38% 65%" }}
                  />
                </div>

              </div>

              <div className="hospitality-driver-card">

                <div className="hospitality-driver-card-text">
                  <h3>Mix & Other</h3>
                  <ul>
                    <li>Guest Mix</li>
                    <li>Promotion</li>
                    <li>Event Mix</li>
                    <li>Tax / Fees</li>
                    <li>Collection Timing</li>
                  </ul>
                </div>

                <div className="hospitality-driver-card-media">
                  <img
                    src="/assets/images/Hotelshero.jpg"
                    alt="Mix & Other"
                    style={{ objectPosition: "78% center" }}
                  />
                </div>

              </div>

            </div>

            <div className="hospitality-example-action-flow">

              <div className="hospitality-example-action">
                <span className="hospitality-example-metric-icon">
                  <Icon type="brain" />
                </span>
                <strong>AI Explains Drivers</strong>
              </div>

              <div className="hospitality-example-action">
                <span className="hospitality-example-metric-icon">
                  <Icon type="gear" />
                </span>
                <strong>Simulate Options</strong>
              </div>

              <div className="hospitality-example-action">
                <span className="hospitality-example-metric-icon">
                  <Icon type="document" />
                </span>
                <strong>Recommend Actions</strong>
              </div>

            </div>

            <div className="hospitality-profit-bar">

              <div className="hospitality-profit-item">
                <Icon type="chart" />
                <span>BETTER PROFITABILITY</span>
              </div>

              <i />

              <div className="hospitality-profit-item">
                <Icon type="layers" />
                <span>LOWER COST</span>
              </div>

              <i />

              <div className="hospitality-profit-item">
                <Icon type="people" />
                <span>HAPPIER GUESTS</span>
              </div>

            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          PORTFOLIO
      ===================================================== */}

      <section className="hospitality-section">
        <div className="hospitality-container">

          <div className="hospitality-section-heading hospitality-reveal">
            <h2>From Single Property to Global Portfolio</h2>
            <p>
              One view. Many properties. Real-time intelligence.
            </p>
          </div>

          <div className="hospitality-portfolio-grid">

            {portfolio.map((item) => (
              <div
                className="hospitality-portfolio-card hospitality-reveal"
                key={item.title}
              >
                <div className="hospitality-portfolio-image">
                  <img src={item.image} alt={item.title} />
                </div>

                <strong>{item.title}</strong>
              </div>
            ))}

          </div>

        </div>
      </section>


      {/* =====================================================
          ENTERPRISE SYSTEMS & DATA
      ===================================================== */}

      <section className="hospitality-section hospitality-enterprise-section" id="enterprise-systems">
        <div className="hospitality-container">

          <div className="hospitality-section-heading hospitality-reveal">
            <h2>Enterprise Systems <span>& Data</span></h2>
            <p>
              Bring Data Together. Add Hospitality Context. Deliver Intelligence.
            </p>
          </div>

          <div className="hospitality-enterprise-data hospitality-reveal">

            <div className="hospitality-systems-grid">

              {enterpriseSystems.map(([name, text, icon], index) => (
                <div
                  className={`hospitality-system-card ${
                    index === 0 ? "hospitality-system-card-primary" : ""
                  }`}
                  key={name}
                >
                  <div className="hospitality-system-icon">
                    <Icon type={icon} />
                  </div>

                  <strong>{name}</strong>
                  <span>{text}</span>
                </div>
              ))}

            </div>

            <div className="hospitality-data-boxes">

              <div className="hospitality-data-box">
                <Icon type="building" />

                <div className="hospitality-data-box-text">
                  <strong>Trusted Hospitality Data</strong>
                  <span>
                    Property | Guest | Room | Revenue | Transactional |
                    Operational | External
                  </span>
                </div>
              </div>

              <div className="hospitality-data-box">
                <Icon type="layers" />

                <div className="hospitality-data-box-text">
                  <strong>Hospitality Semantics & Context</strong>
                  <span>
                    Property | Occupancy | Room Type | Service |
                    Guest Segment | Channel | Market
                  </span>
                </div>
              </div>

              <div className="hospitality-data-box">
                <Icon type="chart" />

                <div className="hospitality-data-box-text">
                  <strong>AI & Decision Intelligence</strong>
                  <span>
                    Explain | Predict | Simulate | Recommend | Act
                  </span>
                </div>
              </div>

            </div>

          </div>

        </div>
      </section>


      {/* =====================================================
          CTA
      ===================================================== */}

      <section className="hospitality-final-cta" id="hospitality-cta">

        <div className="hospitality-container">

          <div className="hospitality-final-cta-inner">

            <div className="hospitality-final-cta-text">

              <h2>
                Build a Smarter
                <br />
                Hospitality Enterprise.
              </h2>

              <a href="/tellusyourproblem#tell-details" className="hospitality-btn primary">
                Tell Us Your Problem
                <Icon type="arrowRight" />
              </a>

            </div>

            <div className="hospitality-final-cta-stats">

              <div className="hospitality-final-cta-stat">
                <div className="hospitality-final-cta-stat-icon">
                  <Icon type="chart" />
                </div>
                <span>Higher<br />Profitability</span>
              </div>

              <div className="hospitality-final-cta-stat">
                <div className="hospitality-final-cta-stat-icon">
                  <Icon type="guest" />
                </div>
                <span>Better Guest<br />Experience</span>
              </div>

              <div className="hospitality-final-cta-stat">
                <div className="hospitality-final-cta-stat-icon">
                  <Icon type="cart" />
                </div>
                <span>Lower<br />Operating Cost</span>
              </div>

              <div className="hospitality-final-cta-stat">
                <div className="hospitality-final-cta-stat-icon">
                  <Icon type="heart" />
                </div>
                <span>A Stronger<br />Brand</span>
              </div>

            </div>

          </div>

        </div>

      </section>

    </main>
  );
}
